import React, { useState } from "react";
import { Link } from "react-router-dom";

const AddClubSociety = () => {
  const [formData, setFormData] = useState({
    clubName: "",
    description: "",
    imageFile: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      imageFile: file,
    });
  };

  const handleCancel = () => {
    setFormData({
      clubName: "",
      description: "",
      imageFile: null,
    });
  };

  const handleSave = () => {
    console.log("Form Data:", formData);
    if (formData.imageFile) {
      console.log("Uploaded File:", formData.imageFile.name);
    }
    alert("Club/Society saved successfully!");
  };

  return (
    <div className="mx-5 mt-5">
      {/* Breadcrumb */}
      <div className="flex items-center text-[25px]">
        <span className="text-gray-400">Research & Student Life</span> / Student Life / 
        <p className="font-semibold">Clubs and Societies</p>
      </div>

      {/* Add and List Buttons */}
      <div className="flex items-center gap-3 mt-5">
        <button className="flex items-center gap-2 bg-[#6B1FBA] text-white px-4 py-2 rounded-lg">
          Add New
        </button>
        <button className="flex items-center gap-2 bg-gray-200 text-gray-700 px-4 py-2 rounded-lg">
          List Table
        </button>
      </div>

      {/* Form Section */}
      <div className="mt-8 bg-white shadow-md rounded-lg p-8">
        <h2 className="text-2xl font-semibold mb-6">Add Club/Society</h2>

        <div className="mb-4">
          <label className="block text-gray-600 mb-2">Club Name</label>
          <input
            type="text"
            name="clubName"
            value={formData.clubName}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            placeholder="Enter club/society name"
          />
        </div>

        <div className="mb-4 flex gap-4">
          <div className="flex flex-col items-center justify-center w-1/3 border border-dashed border-gray-300 rounded-lg p-4">
            <input
              type="file"
              id="image-upload"
              onChange={handleFileChange}
              className="hidden"
            />
            <label
              htmlFor="image-upload"
              className="flex flex-col items-center justify-center cursor-pointer text-purple-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 15a4 4 0 01.88-2.54L9.34 4.7a2 2 0 013.32 0l5.46 7.76A4 4 0 0121 15v0a4 4 0 11-8 0v0a4 4 0 01.88-2.54L9.34 4.7"
                />
              </svg>
              <p className="mt-2 text-sm">Drag and drop image here</p>
              {/* <span className="mt-1 text-sm text-gray-500">or</span> */}
              <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
              <button className="mt-2 px-4 py-2 bg-purple-100 text-purple-600 rounded-lg">
                Browse image
              </button>
            </label>
            {formData.imageFile && (
              <p className="mt-2 text-sm text-gray-600">
                Selected File: {formData.imageFile.name}
              </p>
            )}
          </div>

          <div className="w-2/3">
            <label className="block text-gray-600 mb-2">Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-2"
              rows="6"
              placeholder="Enter description"
            ></textarea>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-4">
          <button
            type="button"
            onClick={handleCancel}
            className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="bg-[#6B1FBA] text-white px-4 py-2 rounded-lg"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddClubSociety;
